import React, { useState, useRef } from 'react';
import { Growl } from 'primereact/growl';

import { Lista } from '../configuracion/Lista';
import { Formulario } from './Formulario';
import { TablaConsultaSolicitudesSat } from '../tablas/TablaConsultaSolicitudesSat';
import servicioObjetos from '../../../servicio/ServicioObjetos';
import servicioHttp from '../../../servicio/ServicioHttp';


const PAGINACION_INICIAL = {
    registrosPorPagina: 50,
    registrosTotales: 0,
    join: {
        'ttSolicitudDescargaCfdi': 'alias_ttSolicitudDescargaCfdi',
        'alias_ttSolicitudDescargaCfdi.tcFiel': 'alias_tcFiel',
    },
    restriccionesDinamicas: [
        {
            tipoRestriccion: "eq",
            nombrePropiedad: "tipoSolicitud",
            valorPropiedad: "Metadata"
        },
        {
            tipoRestriccion: "eq",
            nombrePropiedad: "tipoComprobante",
            valorPropiedad: "N"
        }

    ],
    datos: [],
    ordenamientos: [
        {
            tipo: "asc",
            nombrePropiedad: "fechaInicial"
        }
    ]
}

export const DescargaCfdiNomina = (props) => {

    const urlDescarga = "subsolicitud_descargacfdi/nomina/descargar.json";
    const [empresa, setEmpresa] = useState(null);
    const [tcFielDb, setTcFielDb] = useState(null);
    const [paginacion, setPaginacion] = useState(PAGINACION_INICIAL);
    let growl = useRef(null);

    const buscarSubSolicitudesSat = (laFiel) => {
        if (!servicioObjetos.esObjetoVacio(laFiel)) {
            let laPaginacion = { ...PAGINACION_INICIAL };
            laPaginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_tcFiel.id",
                valorPropiedad: laFiel.id
            });
            servicioHttp.consumirPostHttp('subsolicitud_descargacfdi/consultar.json', laPaginacion).then(response => {
                setPaginacion(response.data.objeto);
            }).catch(error => {

            });
        }
    }

    const onSeleccionEmpresa = (empresaSeleccionada) => {
        if (servicioObjetos.esObjetoVacio(empresaSeleccionada)) {
            empresaSeleccionada = {};
            setEmpresa(null);
            return;
        }
        setEmpresa(empresaSeleccionada);
        let idEmpresa = empresaSeleccionada.value;
        servicioHttp.consumirPostHttp('fiel/buscar_por_empresa.json', { id: idEmpresa }).then(response => {
            let laFiel = response.data.objeto;
            setTcFielDb(laFiel);
            buscarSubSolicitudesSat(laFiel);
        }).catch(error => {
            growl.current.show({ severity: 'error', summary: 'Error', detail: "Existe un error de conexión con el servidor, contacte a un administrador", life: 10000 });
        });
    }

    const onFormularioOk = (objetoFormulario) => {
        let { fechaInicial, fechaFinal } = objetoFormulario;
        fechaFinal.setHours(23, 59, 59);
        if (servicioObjetos.esObjetoVacio(empresa)) {
            growl.current.clear();
            growl.current.show({ severity: 'error', summary: 'Error', detail: 'Debes de elegir una empresa', life: 10000 });
            return;
        }
        if (servicioObjetos.esObjetoVacio(tcFielDb)) {
            growl.current.clear();
            growl.current.show({ severity: 'error', summary: 'Error', detail: 'El rfc seleccionado no cuenta con información de E.firma debes de ingresar E.firma en la sección configuración del menu Descarga Cfdi', life: 10000 });
            return;
        }

        let solicitudDescarga = {};
        solicitudDescarga.tcFiel = {
            id: tcFielDb.id
        }
        solicitudDescarga.fechaInicial = fechaInicial.getTime();
        solicitudDescarga.fechaFinal = fechaFinal.getTime();
        servicioHttp.consumirPostHttp('solicitud_descargacfdi/nomina/guardar.json', solicitudDescarga).then(response => {
            let data = response.data;
            growl.current.show({ severity: data.error ? 'error' : 'success', summary: data.error ? 'Error' : 'Éxito', detail: data.error ? "Existe un error de conexión con el servidor, contacte a un administrador" : 'Solicitud agregada con éxito', life: 10000 });
            buscarSubSolicitudesSat(tcFielDb);
        }).catch(error => {
            growl.current.show({ severity: 'error', summary: 'Error', detail: "Existe un error de conexión con el servidor, contacte a un administrador", life: 10000 });
        });
    }

    return (<div>
        <Growl ref={growl} />
        <div className="p-grid">
            <div className="p-col-12">
                <div className="card">
                    <h1>Descarga de Cfdi Nómina</h1>
                    <p>En este módulo usted puede realizar la solicitud manual para poder descargar CFDI de Nómina</p>
                </div>
            </div>
        </div>
        <div className="p-grid">
            <div className="p-col-12">
                <div className="card">
                    <Lista onSeleccionEmpresa={onSeleccionEmpresa} />
                </div>
            </div>
        </div>
        <div className="p-grid">
            <div className="p-col-12">
                <div className="card">
                    <Formulario onFormularioOk={onFormularioOk} growl={growl} />
                </div>
            </div>
        </div>
        <div className="card">
            <TablaConsultaSolicitudesSat paginacion={paginacion} urlDescarga={urlDescarga} growl={growl} />
        </div>

    </div>);
}